<div class="row card-header">
  <h3>Forgot Password</h3>
</div>

<div class="col-12" *ngIf="erroralert">
  <div class="alert-box grid-100" *ngIf="errorMessage">
    <div class="alert alert-danger mt-3 text-center">
      <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
      {{errorMessage}}
    </div>
  </div>
</div>
<div class="col-12" *ngIf="successalert">
  <div class="alert-box grid-100" *ngIf="successMessage">
    <div class="alert alert-success mt-3 text-center">
      <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
      {{successMessage}}
    </div>
  </div>
</div>
<!-- <div class="row bg_dashboard justify-content-center">
  <div class="col-11">
    <div class="card text-center">
      <div class="card-body card_main">
         <form class="viewProfileForm" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm.value); resetPasswordForm.reset()">
          <div class="row justify-content-center">
            <div class="col-4">
              <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label">Password</label>
                <div class="col-sm-10">
                  <input type="password" class="form-control" id="inputPassword" placeholder="Password" required name="password" formControlName="password" (focus)="onFocusFunction()">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label">Password</label>
                <div class="col-sm-10">
                  <input type="password" required name="passwordConfirmation" formControlName="passwordConfirmation"  (focus)="onFocusFunction()" (keyup)="matchpasswords($event.target.value)" class="form-control"  placeholder="Password" required name="password" formControlName="password" (focus)="onFocusFunction()">
                </div>
              </div>
              <button class="button mt-3" type="submit"  [disabled]="!resetPasswordForm.valid">Submit</button>
              <div class="form-group">
                <input type="password" class="form-control" placeholder="Enter New Password"  id="password" required name="password" formControlName="password" (focus)="onFocusFunction()">
                 <div *ngIf="resetPasswordForm.controls['password'].errors && !resetPasswordForm.controls['password'].pristine" class="text-danger">
                    <div [hidden]="!resetPasswordForm.controls['password'].errors.required">Password is required.</div>
                    <div [hidden]="!resetPasswordForm.controls['password'].errors.minlength">Password must be at least 8 characters long.</div>
                  </div>
                <input type="password" class="form-control" placeholder="Confirm Password"  id="passwordConfirmation" required name="passwordConfirmation" formControlName="passwordConfirmation"  (focus)="onFocusFunction()" (keyup)="matchpasswords($event.target.value)">
                <div *ngIf="resetPasswordForm.controls['passwordConfirmation'].errors && !resetPasswordForm.controls['passwordConfirmation'].pristine" class="text-danger">
                  <div [hidden]="!resetPasswordForm.controls['passwordConfirmation'].errors.required">Confirm Password is required.</div>
                </div>
                <p *ngIf="passwordmatchFlag" class="text-danger">  Password doesn't match!</p>
                <button class="button mt-3" type="submit"  [disabled]="!resetPasswordForm.valid">Submit</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> -->

<div class="container">
  <form  [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm.value); resetPasswordForm.reset()">
    <div class="form-group row justify-content-center">
      <label for="inputPassword" class="col-sm-2 col-form-label">New Password:</label>
      <div class="col-sm-10 col-lg-6">
        <input type="password" class="form-control" id="inputPassword" placeholder="Password" required name="password" formControlName="password" (focus)="onFocusFunction()">
      </div>
    </div>

    <div *ngIf="resetPasswordForm.controls['password'].errors && !resetPasswordForm.controls['password'].pristine" class="text-danger">
       <div style="text-align: center; margin-bottom: 13px;" [hidden]="!resetPasswordForm.controls['password'].errors.required">Password is required.</div>
       <div style="text-align: center; margin-bottom: 13px;" [hidden]="!resetPasswordForm.controls['password'].errors.minlength">Password must be at least 8 characters long.</div>
     </div>

    <div class="form-group row justify-content-center">
      <label for="inputPassword" class="col-sm-2 col-form-label">Confirm Password:</label>
      <div class="col-sm-10 col-lg-6">
        <input type="password" class="form-control" placeholder="Confirm Password"  id="passwordConfirmation" required name="passwordConfirmation" formControlName="passwordConfirmation"  (focus)="onFocusFunction()" (keyup)="matchpasswords($event.target.value)">
      </div>
    </div>

    <div *ngIf="resetPasswordForm.controls['passwordConfirmation'].errors && !resetPasswordForm.controls['passwordConfirmation'].pristine" class="text-danger">
      <div style="text-align: center; margin-bottom: 13px;" [hidden]="!resetPasswordForm.controls['passwordConfirmation'].errors.required">Confirm Password is required.</div>
    </div>
    <p style="text-align: center; margin-bottom: 13px;" *ngIf="passwordmatchFlag" class="text-danger">  Password doesn't match!</p>

    <div align="center">
      <button class="button mt-3" type="submit"  [disabled]="!resetPasswordForm.valid">Submit</button>
    </div>
  </form>

</div>



// WEBPACK FOOTER //
// ./src/app/authentication/forgotpassword/forgotpassword.component.html